import { FETCH_OVERSIZE_FIELD_MOISTURES } from "../actions/types";

const initialState = {
  items: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case FETCH_OVERSIZE_FIELD_MOISTURES:
      return {
        ...state,
        items: action.payload
      };
    default:
      return state;
  }
}
